import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";
import { PreparationOrderProduct } from "@/model/preparation/PreparationOrderProduct";
import { PreparationOrderStatus } from "@/model/preparation/PreparationOrderStatus";
import {CancellationRequest} from "@/model/preparation/CancellationRequest";
import {PreparationType} from "@/model/preparation/PreparationType";

export class PreparationOrder implements Serializable {
    orderId: string;
    orderNumber: string;
    opNumber: string;
    channel: string;
    storeId: string;
    preparationType: PreparationType;
    pickupDate: Date;
    frontOffice: string;
    customerId: number;
    type: string;
    driveId: string;
    products: PreparationOrderProduct[];

    status: PreparationOrderStatus;
    cancellationRequest: CancellationRequest;
    urgent: boolean = false;
    orderIds: string[] = [];

    fromJSON(rawObject: any): void {
        SerializationHelper.copyNonExcludedProperties(this, rawObject, ['products']);

        if (rawObject['products'] != null) {
            this.products = SerializationHelper.toArrayInstanceFromJsonObjArray(() => new PreparationOrderProduct(), rawObject['products']);
        }
    }
}
